'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { useAlertContext } from './AlertContext';
import { alertTheme } from './theme';
const AlertTitle = forwardRef(({ children, className, ...props }, ref) => {
    const { title } = alertTheme;
    const { color = 'secondary' } = useAlertContext();
    return (_jsx("p", { ...props, className: cn(title.base, title.color[color], className), ref: ref, children: children }));
});
AlertTitle.displayName = 'AlertTitle';
export { AlertTitle };
